//
//
//
//
//
//
//
//
//
//
//
import Bus from '@/util/eventBus';
import shareComp from './Share';
export default {
  components: {
    shareComp: shareComp
  },
  data: function data() {
    return {
      visible: false,
      type: 0,
      // 0自己晒|1赠送他人
      orderid: '',
      num: 0,
      sendDesc: ''
    };
  },
  methods: {
    openShare: function openShare() {
      this.visible = true;
    },
    closeShare: function closeShare() {
      this.visible = false;
    },
    bindEvent: function bindEvent() {
      var _this = this;

      Bus.$on('launchShare', function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$type = _ref.type,
            type = _ref$type === void 0 ? 0 : _ref$type,
            _ref$orderid = _ref.orderid,
            orderid = _ref$orderid === void 0 ? '' : _ref$orderid,
            _ref$num = _ref.num,
            num = _ref$num === void 0 ? 0 : _ref$num,
            _ref$sendDesc = _ref.sendDesc,
            sendDesc = _ref$sendDesc === void 0 ? '' : _ref$sendDesc;

        _this.type = type;
        _this.orderid = orderid;
        _this.num = num;
        _this.sendDesc = sendDesc;

        _this.openShare();
      });
    }
  },
  mounted: function mounted() {
    this.bindEvent();
  }
};